module.exports = __webpack_public_path__ + "img/in_progress.37d9ccba.svg";